export default __webpack_public_path__ + "static/media/partnership.db9c9943.webp";